/* TIMELESS MOONLIGHT MELTS — volume tier ladder.

   Tiers are MIX AND MATCH and CART-WIDE, so the ladder reads the basket, not
   just the quantity box. Every melt already in the cart counts toward the next
   tier, whichever scent it is.

   WHAT ENFORCES THIS AT CHECKOUT
   Two native Shopify automatic discounts on the All Melts collection:

     "10+ melts — 55p each"   £0.15 off each item, minimum quantity 10
     "20+ melts — 50p each"   £0.20 off each item, minimum quantity 20

   Both are "amount off each item", so the price is a flat rate per melt once
   you cross a threshold — NOT a bundle fill. 15 melts is 15 x 55p = £8.25,
   not £5.50 + 5 x 70p. This file must model the same rate ladder or the page
   will promise a price checkout does not honour.

   Because they are per-item amounts and every melt is exactly £0.70, the
   arithmetic is exact in pence at every quantity — no rounding drift.

   Only one product discount applies per line on a non-Plus plan, and Shopify
   picks the better one, so at 20+ the 50p rate wins. Verified live at 1, 4, 5,
   9, 10, 11, 15, 19, 20, 21, 25, 30 and 40 melts.

   Melt detection here uses product_type === 'Wax Melt'. Verified 1:1 against
   the All Melts collection the discounts target: 319 products in the
   collection, 319 of that type, none either side. If that ever drifts apart
   the page and checkout will disagree.
*/
(function () {
  var cfg = window.TMM_MELT_TIERS;
  if (!cfg || !cfg.tiers || !cfg.tiers.length) return;

  var CUR = cfg.currency || '£';
  var unit = Number(cfg.unit) || 0;
  if (unit <= 0) return;

  /* Ascending by quantity. Each entry is a THRESHOLD and the flat per-melt
     rate that applies at or above it. */
  var tiers = cfg.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
  var top = tiers[tiers.length - 1];
  var topRate = Number(top.rate);

  var cartMelts = 0;

  function money(n) { return CUR + n.toFixed(2); }
  function pence(n) { return n < 1 ? Math.round(n * 100) + 'p' : money(n); }

  /* The flat rate that applies to n melts. Below the first threshold, list. */
  function rateFor(n) {
    var rate = unit;
    for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].qty) rate = Number(tiers[i].rate);
    return rate;
  }

  function bestPrice(n) { return n * rateFor(n); }

  function tierFor(n) {
    var hit = null;
    for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].qty) hit = tiers[i];
    return hit;
  }

  /* The next threshold that would actually lower the rate. */
  function nextTier(n) {
    var rate = rateFor(n);
    for (var i = 0; i < tiers.length; i++) {
      if (n < tiers[i].qty && Number(tiers[i].rate) < rate) return tiers[i];
    }
    return null;
  }

  /* ---- build ----------------------------------------------------------- */
  var wrap = document.createElement('div');
  wrap.className = 'tmm-mt';
  wrap.innerHTML =
    '<div class="tmm-mt__head">' +
      '<span class="tmm-mt__title">Mix &amp; match</span>' +
      '<span class="tmm-mt__sub">Any scents, across the whole shop</span>' +
    '</div>' +
    '<div class="tmm-mt__rows"></div>' +
    '<div class="tmm-mt__nudge" hidden></div>';

  var rows = wrap.querySelector('.tmm-mt__rows');
  var nudge = wrap.querySelector('.tmm-mt__nudge');
  var sub = wrap.querySelector('.tmm-mt__sub');

  tiers.forEach(function (t) {
    var rate = Number(t.rate);
    var total = t.qty * rate;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tmm-mt__row';
    b.dataset.qty = String(t.qty);
    b.setAttribute('aria-label', 'Set quantity to ' + t.qty + ' melts for ' + money(total));
    b.innerHTML =
      '<span class="tmm-mt__qty">' + t.qty + ' melts' +
        (t.qty === top.qty ? '<span class="tmm-mt__flag">Best value</span>' : '') +
      '</span>' +
      '<span class="tmm-mt__price">' + money(total) + '</span>' +
      '<span class="tmm-mt__each">' + pence(rate) + ' each</span>';
    rows.appendChild(b);
  });

  /* ---- place: directly under the quantity + add-to-cart row ------------ */
  var qtyInput =
    document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
    document.querySelector('input[name="quantity"]');
  if (!qtyInput) return;

  var cartRow =
    qtyInput.closest('.product__submit-form-cart') ||
    qtyInput.closest('.product-form__quantity') ||
    qtyInput.closest('.quantity');
  if (!cartRow || !cartRow.parentElement) return;
  cartRow.parentElement.insertBefore(wrap, cartRow.nextSibling);

  /* ---- cart ------------------------------------------------------------ */
  function countMelts(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (item.product_type === 'Wax Melt') n += item.quantity;
    });
    return n;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartMelts = countMelts(cart); render(); })
      .catch(function () { /* leave the last known count in place */ });
  }

  /* Any add/change/update to the cart should re-read it. Patching fetch and
     XHR catches Milano's own cart calls plus anything an app fires. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)/;

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var out = _fetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        if (CART_WRITE.test(url)) out.then(function () { setTimeout(refreshCart, 150); });
      } catch (e) {}
      return out;
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (typeof url === 'string' && CART_WRITE.test(url)) {
        this.addEventListener('load', function () { setTimeout(refreshCart, 150); });
      }
    } catch (e) {}
    return _open.apply(this, arguments);
  };

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCart();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---- render ---------------------------------------------------------- */
  function render() {
    var q = parseInt(qtyInput.value, 10);
    if (!q || q < 1) q = 1;

    var pending = cartMelts + q;

    sub.textContent = cartMelts > 0
      ? cartMelts + (cartMelts === 1 ? ' melt' : ' melts') + ' in your basket'
      : 'Any scents, across the whole shop';

    var active = tierFor(pending);
    Array.prototype.forEach.call(rows.children, function (el) {
      el.classList.toggle('is-active', !!active && Number(el.dataset.qty) === active.qty);
    });

    nudge.hidden = false;

    /* Already at the best rate — every further melt is the top unit price. */
    if (cartMelts >= top.qty) {
      nudge.className = 'tmm-mt__nudge tmm-mt__nudge--saving';
      nudge.innerHTML =
        'You’re on the best rate — every melt you add is just <b>' + pence(topRate) + '</b>';
      return;
    }

    var payTotal = bestPrice(pending);
    var next = nextTier(pending);

    /* Just short of a threshold you can pay MORE than the threshold costs
       (19 melts is £10.45; 20 is £10.00). Say so plainly rather than let
       someone check out on the worse side of it. */
    if (next) {
      var nextTotal = bestPrice(next.qty);
      if (nextTotal <= payTotal + 0.001) {
        nudge.className = 'tmm-mt__nudge tmm-mt__nudge--saving';
        nudge.innerHTML =
          'Add <b>' + (next.qty - pending) + ' more</b> and pay <b>' + money(nextTotal) +
          '</b> — less than the ' + money(payTotal) + ' you’re paying now';
        return;
      }
      nudge.className = 'tmm-mt__nudge';
      nudge.innerHTML =
        'Add <b>' + (next.qty - pending) + ' more</b> and every melt drops to ' +
        pence(Number(next.rate)) + ' — ' + money(nextTotal) + ' for ' + next.qty;
      return;
    }

    /* At or past the top threshold on this page, but the cart is not yet. */
    nudge.className = 'tmm-mt__nudge tmm-mt__nudge--saving';
    nudge.innerHTML =
      'That’s <b>' + pending + ' melts</b> for ' + money(payTotal) +
      ' — every extra melt after that is ' + pence(topRate);
  }

  rows.addEventListener('click', function (e) {
    var btn = e.target.closest('.tmm-mt__row');
    if (!btn) return;
    /* The rows are basket targets, so subtract what is already in the cart. */
    var want = Math.max(1, Number(btn.dataset.qty) - cartMelts);
    qtyInput.value = want;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    render();
  });

  ['input', 'change', 'keyup'].forEach(function (evt) {
    qtyInput.addEventListener(evt, render);
  });
  new MutationObserver(render).observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

  render();
  refreshCart();
})();
